{#if hamburgerMenu} <!--Hamburger Menu-->
  <div class="nav-icon {navMenuOpen ? 'open' : 'closed'}" on:click={toggleMenu} bind:this={burgerIcon}>
    <span class="nav-icon-line" style="background: {navMenuOpen ? fields.textColour || 'black' : fields.burgerColour || 'black'};"></span>
    <span class="nav-icon-line" style="background: {navMenuOpen ? fields.textColour || 'black' : fields.burgerColour || 'black'};"></span>
    <span class="nav-icon-line" style="background: {navMenuOpen ? fields.textColour || 'black' : fields.burgerColour || 'black'};"></span>
  </div>
  {#if fields.hamburgerStyle === 'slide-from-side' && mounted}
    <div class="jolojo-menu__slide_from_side {navMenuOpen ? 'open' : 'closed'} {burgerIconPosition}"
      style="
        {burgerIconPosition === 'right'
          ? `padding-right: ${burgerIconDistanceFromRight}px;`
          : `padding-left: ${burgerIconDistanceFromLeft}px;`
        }
        padding-top: {burgerIconDistanceFromTop}px;
          background-color: {fields.backgroundColour || 'white'}; color: {fields.textColour || 'inherit'};
      "
    >
      <div class="menu-items-container">
        {#each fields.menuItems as item}
          <div class="menu-item">
            <div class="parent">
              <svelte:element this={item.url ? 'a' : 'span'} href={item.url || null} target={item.newTab ? '_blank' : '_self'}
                style="color: {fields.textColour || 'inherit'}"
                on:click={() => { toggleExpand(item) }}
              >
                {item.name}
              </svelte:element>
              {#if item?.childItems?.length}
                {#if item.showChildren}
                  <span class="expand-icon" on:click={() => { item.showChildren = false }}> - </span>
                {:else}
                  <span class="expand-icon" on:click={() => { item.showChildren = true }}> + </span>
                {/if}
              {/if}
            </div>
            <div class="child-items {item.showChildren ? 'expanded' : 'hidden'}">
              {#each item?.childItems || [] as childItem}
                <a href="{childItem.url}" style="color: {fields.textColour || 'inherit'}" target={childItem.newTab ? '_blank' : '_self'}>
                  {childItem.name}
                </a>
              {/each}
            </div>
          </div>
        {/each}
        {#each fields.featuredItems || [] as featuredItem}
          <a class="menu-item featured" href={featuredItem.url} target={featuredItem.newTab ? '_blank' : '_self'}
            style={`
              ${fields?.featuredStyle?.textColour ? `color: ${fields?.featuredStyle?.textColour};` : ''}
              ${fields?.featuredStyle?.backgroundColour ? `background-color: ${fields?.featuredStyle?.backgroundColour};` : ''}
            `}
          >
            {featuredItem.name}
          </a>
        {/each}
      </div>
    </div>
  {:else}
    <nav class={`jolojo-burger-menu ${navMenuOpen ? 'open' : navMenuClicked ? 'closed' : 'closed-pre-click'} ${editMode ? 'edit-mode' : ''}`}>
      <div class="overlay" style="background-color: {fields.backgroundColour || 'black'}; opacity: {fields.backgroundOpacity / 100 || 100}"></div>
      <div class="menu-container"
        style="color: {fields.textColour || 'inherit'};
          top: {isMobile ? '70' : burgerIconDistanceFromTop + 70}px;
            height: calc(100vh - {isMobile ? '70' : burgerIconDistanceFromTop + 70}px);
          {burgerIconPosition === 'left'
            ? `left: ${isMobile ? '20' : burgerIconDistanceFromLeft}px;`
            : `left: ${isMobile ? '20' : burgerIconDistanceFromRight}px;`
          }
          {burgerIconPosition === 'left'
            ? `width: ${isMobile ? '100%' : 'calc(100vw - ' + burgerIconDistanceFromLeft * 2}px);`
            : `width: ${isMobile ? '100%' : 'calc(100vw - ' + burgerIconDistanceFromRight * 2}px);`
          }"
        bind:this={menuContainerRef}
      >
        {#if navMenuOpen}
          <div class="parent-items {childItemsToDisplay !== null ? 'item-selected' : ''}" bind:this={parentItemsRef}>
            {#each fields.menuItems || [] as item, i}
              <div class="menu-item {childItemsToDisplay !== i && childItemsToDisplay ? 'not-selected' : 'selected'}" bind:this={menuRefs[i]}
              >
                {#if !item?.childItems?.length}
                  <a href={item.url} color={fields.textColour || 'black'} target={item.newTab ? '_blank' : '_self'}>{item.name}</a>
                {:else}
                  {#if item.url}
                    <a href={item.url} color={fields.textColour || 'black'} target={item.newTab ? '_blank' : '_self'}>{item.name}</a>
                    <button
                      style="color: inherit;"
                      on:mouseenter={() => { if (!isMobile) { childItemsToDisplay = i } }}
                      on:click={() => { childItemsToDisplay !== i ? childItemsToDisplay = i : childItemsToDisplay = null }}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' height="24" viewBox="0 -960 960 960" width="24"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>
                    </button>
                  {:else}
                    <span
                      color={fields.textColour || 'black'}
                      on:click={() => { childItemsToDisplay !== i ? childItemsToDisplay = i : childItemsToDisplay = null }}>
                      {item.name}
                    </span>
                    <button
                      style="color: inherit;"
                      on:mouseenter={() => { if (!isMobile) { childItemsToDisplay = i } }}
                      on:click={() => { childItemsToDisplay !== i ? childItemsToDisplay = i : childItemsToDisplay = null }}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' height="24" viewBox="0 -960 960 960" width="24"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>
                    </button>
                  {/if}
                {/if}
              </div>
            {/each}
            {#each fields.featuredItems || [] as featuredItem}
              <a class="menu-item featured" href={featuredItem.url} target={featuredItem.newTab ? '_blank' : '_self'}
                style={`
                  ${fields?.featuredStyle?.textColour ? `color: ${fields?.featuredStyle?.textColour};` : ''}
                  ${fields?.featuredStyle?.backgroundColour ? `background-color: ${fields?.featuredStyle?.backgroundColour};` : ''}
                `}
              >
                {featuredItem.name}
              </a>
            {/each}
          </div>
          {#if childItemsToDisplay !== null}
            <div class="children-menu" bind:this={childItemsRef}>
              {#if isMobile}
                <div class="back-chevrons">
                  <button on:click={() => { childItemsToDisplay = null }}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' height="24" viewBox="0 -960 960 960" width="24"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>
                  </button>
                </div>
              {/if}
              <div class="child-items">
                {#each fields.menuItems[childItemsToDisplay].childItems || [] as childItem}
                  <div class="menu-item">
                    <a href="{childItem.url}" target={childItem.newTab ? '_blank' : '_self'}>{childItem.name}</a>
                  </div>
                {/each}
              </div>
            </div>
          {/if}
        {/if}
      </div>
    </nav>
  {/if}
{:else} <!--Regular Menu-->
  <nav class="jolojo-parent-menu {hideMenu ? 'hide-menu' : ''}"
    style="
      color: {fields.textColour || 'inherit'};"
  >
    {#each fields.menuItems || [] as item, i}
      <div class="menu-item" class:current={$url.pathname === item.url}>
        <svelte:element
          this={item.url ? 'a' : 'div'}
          href={item.url || null}
          target={item.newTab ? '_blank' : '_self'}
        >
          {item.name}
        </svelte:element>
        {#if item?.childItems?.length}
          <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 -960 960 960" width="25px" fill="currentColor">
            <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"/>
          </svg>
          <div class="children-menu"
            style="
              background-color: {fields.backgroundColour || 'white'};
                color: {fields.textColour || 'inherit'};"
          >
            {#each item.childItems || [] as childItem}
              <a href="{childItem.url}" target={childItem.newTab ? '_blank' : '_self'}>
                {childItem.name}
              </a>
            {/each}
          </div>
        {/if}
      </div>
    {/each}
    {#each fields.featuredItems || [] as featuredItem}
      <a class="menu-item featured" href={featuredItem.url} target={featuredItem.newTab ? '_blank' : '_self'}
        style={`
          ${fields?.featuredStyle?.textColour ? `color: ${fields?.featuredStyle?.textColour};` : ''}
          ${fields?.featuredStyle?.backgroundColour ? `background-color: ${fields?.featuredStyle?.backgroundColour};` : ''}
        `}
      >
        {featuredItem.name}
      </a>
    {/each}
  </nav>
{/if}

<svelte:window bind:innerWidth={windowWidth} />

<script>
  import { getContext, onMount } from 'svelte'

  const platform = getContext('platform')
  const editMode = platform.api.core.hasScope('super', 'admin')
  let mounted = false

  onMount(() => {
    mounted = true
  })

  const { url } = platform.router

  export let fields = {}

  let windowWidth = 0

  let hamburgerMenu = fields.hamburgerMenu
  let hideMenu = false

  let burgerIcon = null
  let burgerIconDistanceFromTop = 0
  let burgerIconDistanceFromRight = 0
  let burgerIconDistanceFromLeft = 0
  let burgerIconPosition = null

  let menuContainerRef = null
  let parentItemsRef = null
  let childItemsRef = null

  const menuRefs = []
  let navMenuOpen = false

  let navMenuClicked = false

  let childItemsToDisplay = null

  let isMobile = true

  $: if ($url) {
    closeMenu()
  }

  $: if (fields) {
    hamburgerMenu = fields.hamburgerMenu
  }

  $: if (windowWidth < fields.responsiveSize) {
    switch (fields.responsiveAction) {
      case 'burger':
        hamburgerMenu = true
        break
      case 'hide':
        hideMenu = true
        break
      default:
        break
    }
  } else {
    switch (fields.responsiveAction) {
      case 'burger':
        hamburgerMenu = false
        break
      case 'hide':
        hideMenu = false
        break
      default:
        break
    }
  }

  $: {
    if (windowWidth < 650) {
      isMobile = true
    } else {
      isMobile = false
    }

    if (burgerIcon) {
      burgerIconDistanceFromTop = burgerIcon.getBoundingClientRect().top + window.scrollY
      burgerIconDistanceFromRight = windowWidth - burgerIcon.getBoundingClientRect().right
      burgerIconDistanceFromLeft = burgerIcon.getBoundingClientRect().left

      if (burgerIcon.getBoundingClientRect().right > (windowWidth / 2)) {
        burgerIconPosition = 'right'
      } else {
        burgerIconPosition = 'left'
      }
    }
  }

  function toggleMenu () {
    if (!navMenuOpen) {
      if (isMobile) {
        if (fields.hamburgerStyle !== 'slide-from-side') {
          const currentPosition = window.scrollY
          const offset = 30
          const targetPosition = burgerIcon.getBoundingClientRect().top + currentPosition - offset
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          })
        }
      }
      navMenuClicked = true
      navMenuOpen = true
      document.documentElement.style.overflow = 'hidden'
      if (!isMobile) {
        document.documentElement.style.marginRight = '15px'
      }
    } else {
      closeMenu()
    }
  }

  function closeMenu () {
    childItemsToDisplay = null
    navMenuOpen = false

    if (mounted) {
      document.documentElement.style.overflow = 'auto'
      document.documentElement.style.marginRight = '0px'
    }
  }

  function toggleExpand (item) {
    if (item?.childItems?.length) {
      item.showChildren = !item.showChildren
    }
  }
</script>

<style lang="scss">.jolojo-parent-menu {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}
.jolojo-parent-menu.hide-menu {
  display: none;
}
.jolojo-parent-menu .children-menu {
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 1rem;
  max-height: 0px;
  z-index: 10;
  min-width: 100%;
  left: -1rem;
  padding: 0 1rem;
  opacity: 0;
  transition: 0.5s;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.jolojo-parent-menu .menu-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  white-space: nowrap;
}
.jolojo-parent-menu .menu-item svg {
  transition: 0.5s;
}
.jolojo-parent-menu .menu-item:hover svg {
  transform: rotate(-180deg);
}
.jolojo-parent-menu .menu-item:hover .children-menu {
  max-height: 750px;
  opacity: 1;
  padding: 1rem;
}

.nav-icon {
  width: 30px;
  height: 22.5px;
  transform: rotate(0deg);
  transition: 0.6s ease-in-out;
  cursor: pointer;
  z-index: 110;
  position: relative;
}

.nav-icon-line {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.3s ease-in-out;
}

.nav-icon span:nth-child(1) {
  top: 0px;
}

.nav-icon span:nth-child(2) {
  top: 50%;
  transform: translate(0, -50%);
}

.nav-icon span:nth-child(3) {
  transform: translate(0, -100%);
  top: 100%;
}

.nav-icon.open span:nth-child(1) {
  top: 14px;
  transform: rotate(135deg);
}

.nav-icon.open span:nth-child(2) {
  opacity: 0;
  left: -60px;
}

.nav-icon.open span:nth-child(3) {
  top: 14px;
  transform: rotate(-135deg);
}

.jolojo-burger-menu {
  position: fixed;
  left: 0px;
  top: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 100;
}
.jolojo-burger-menu .parent-items {
  overflow-y: auto;
  min-width: fit-content;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.jolojo-burger-menu .parent-items::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 650px) {
  .jolojo-burger-menu .parent-items {
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    position: absolute;
    transition: 0.3s transform;
  }
  .jolojo-burger-menu .parent-items.item-selected {
    transform: translateX(-100%);
  }
}
.jolojo-burger-menu .overlay {
  transition: 0.8s;
  position: fixed;
  display: block;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.jolojo-burger-menu button {
  background: none;
  border: none;
  cursor: pointer;
}
.jolojo-burger-menu.closed .overlay, .jolojo-burger-menu.closed-pre-click .overlay {
  opacity: 0;
  transform: translate(-100%, -100%);
}
.jolojo-burger-menu.open .overlay {
  transform: translate(0, 0);
}
.jolojo-burger-menu .menu-container {
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  opacity: 0;
  transition: 0.3s;
  z-index: 100;
  width: calc(100vw - 40px);
}
@media screen and (min-width: 650px) {
  .jolojo-burger-menu .menu-container {
    padding-bottom: 30px;
  }
}
.jolojo-burger-menu .menu-item.menu-item.featured {
  margin: 1rem;
}
.jolojo-burger-menu .children-menu {
  display: flex;
  gap: 5vw;
  width: 100%;
}
.jolojo-burger-menu .child-items {
  overflow-y: auto;
  width: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.jolojo-burger-menu .child-items::-webkit-scrollbar {
  display: none;
}
.jolojo-burger-menu.open .menu-container {
  animation-name: fadeIn;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-delay: 150ms;
  display: flex;
}
.jolojo-burger-menu.closed .menu-container {
  animation-name: fadeOut;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  display: none;
}
@media screen and (min-width: 650px) {
  .jolojo-burger-menu.open .child-items {
    opacity: 0;
    animation-name: fadeIn;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
  }
}
@media screen and (max-width: 650px) {
  .jolojo-burger-menu.open .child-items {
    animation-name: slideIn;
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }
}
.jolojo-burger-menu .menu-item {
  position: relative;
  z-index: inherit;
  display: flex;
  align-items: center;
  gap: 5vw;
  justify-content: space-between;
  padding: 1rem;
}
.jolojo-burger-menu .menu-item.not-selected {
  opacity: 0.5;
}
.jolojo-burger-menu svg {
  height: 30px;
  width: auto;
}

.jolojo-menu__slide_from_side {
  position: fixed;
  top: 0;
  height: 100vh;
  transition: 0.3s;
  z-index: 100;
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.jolojo-menu__slide_from_side .parent {
  justify-content: space-between;
}
.jolojo-menu__slide_from_side.open {
  transform: translateX(0%);
}
.jolojo-menu__slide_from_side.right {
  right: 0;
}
.jolojo-menu__slide_from_side.right.closed {
  transform: translateX(100%);
}
.jolojo-menu__slide_from_side.left {
  left: 0;
}
.jolojo-menu__slide_from_side.left.closed {
  transform: translateX(-100%);
}
.jolojo-menu__slide_from_side ::-webkit-scrollbar {
  width: 10px;
}
.jolojo-menu__slide_from_side ::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
.jolojo-menu__slide_from_side ::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}
.jolojo-menu__slide_from_side ::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}
.jolojo-menu__slide_from_side .menu-items-container {
  display: flex;
  flex-direction: column;
  padding: 0 4rem;
  max-width: 100%;
  gap: 1rem;
  max-height: calc(100% - 6rem);
  overflow-y: auto;
  position: relative;
  top: 4rem;
  bottom: 2rem;
}
.jolojo-menu__slide_from_side .parent {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.jolojo-menu__slide_from_side .expand-icon {
  cursor: pointer;
  width: 25px;
  display: grid;
  place-items: center;
}
.jolojo-menu__slide_from_side .child-items {
  height: 0px;
  padding-left: 2rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.jolojo-menu__slide_from_side .child-items.expanded {
  margin-top: 1rem;
  height: auto;
}

.menu-item.featured {
  padding: 0.5rem 1rem;
  border-radius: 5px;
  width: fit-content;
  transition: 0.3s;
}
.menu-item.featured:hover {
  text-decoration: none;
  padding: 0.5rem 1.25rem;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes slideIn {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>